const utils = require('../utils');

const FALLBACK_IMAGE = "https://dr1k2g3wmnols.cloudfront.net/images/common/vehicle-placeholder.png";
const DEFAULT_IMAGE_DIMENSIONS = {
    width: 1280,
    height: 853
};

const getImageSource = (imageElement) => {
    if (!imageElement) {
        return FALLBACK_IMAGE;
    }

    const placeholderSrc = imageElement.getAttribute('data-placeholder-image') || FALLBACK_IMAGE;
    const fullSrc = imageElement.getAttribute('data-full-src');
    const realSrc = fullSrc || imageElement.getAttribute('data-src') || imageElement.getAttribute('src');

    if (!realSrc || realSrc === placeholderSrc) {
        return FALLBACK_IMAGE;
    }

    return realSrc;
};

const getThumbnailSource = (imageElement) => {
    if (!imageElement) {
        return FALLBACK_IMAGE;
    }

    return imageElement.currentSrc || imageElement.getAttribute('src') || imageElement.getAttribute('data-src') || FALLBACK_IMAGE;
};

const getThumbnailBounds = (item) => {
    const slideElement = item && item.el && item.el.jquery ? item.el[0] : item && item.el;
    const imageElement = slideElement && slideElement.querySelector('img');

    if (!imageElement) {
        return null;
    }

    const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
    const rect = imageElement.getBoundingClientRect();

    return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
};

const initPhotoSwipeFromDOM = function (gallerySelector) {
    // parse slide data (url, title, size ...) from DOM elements
    // (children of gallerySelector)
    const parseThumbnailElements = function (el) {
        const items = [];

        Array.from(el.children).forEach((node, swiperIndex) => {
            const $node = $(node);
            if (!$node.hasClass('swiper-slide')) {
                return;
            }

            const linkEl = $node.find('picture img')[0];
            if (!linkEl) {
                // If there's no image, skip slides that only contain video
                if ($node.find('video')[0]) {
                    return;
                }

                items.push({
                    src: FALLBACK_IMAGE,
                    w: DEFAULT_IMAGE_DIMENSIONS.width,
                    h: DEFAULT_IMAGE_DIMENSIONS.height,
                    el: node,
                    swiperIndex,
                    msrc: FALLBACK_IMAGE
                });
                return;
            }

            const imageSrc = getImageSource(linkEl);
            const thumbnailSrc = getThumbnailSource(linkEl);

            items.push({
                src: imageSrc,
                w: DEFAULT_IMAGE_DIMENSIONS.width,
                h: DEFAULT_IMAGE_DIMENSIONS.height,
                el: node,
                swiperIndex,
                msrc: thumbnailSrc
            });
        });

        return items;
    };

    // find nearest parent element
    const closest = function closest(el, fn) {
        return el && (fn(el) ? el : closest(el.parentNode, fn));
    };

    // triggers when user clicks on thumbnail
    const onThumbnailsClick = function (e) {
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;

        const eTarget = e.target || e.srcElement;
        // find root element of slide
        const clickedListItem = closest(eTarget, function (el) {
            return (el.tagName && el.tagName.toUpperCase() === 'IMG');
        });

        if (!clickedListItem) {
            return;
        }

        // find index of clicked item by looping through all child nodes
        // alternatively, you may define index via data- attribute
        let clickedGallery = clickedListItem.parentNode.parentNode.parentNode,
            childNodes = clickedListItem.parentNode.parentNode.parentNode.childNodes,
            numChildNodes = childNodes.length,
            nodeIndex = 0,
            index;

        for (let i = 0; i < numChildNodes; i++) {
            if (childNodes[i].nodeType !== 1 || !!$(childNodes[i])?.find('video')?.[0]) {
                continue;
            }
            if (childNodes[i] === clickedListItem.parentNode.parentNode) {
                index = nodeIndex;
                break;
            }
            nodeIndex++;
        }

        if (index >= 0) {
            // open PhotoSwipe if valid index found
            openPhotoSwipe(index, clickedGallery);
        }
        return false;
    };

    // parse picture index and gallery index from URL (#&pid=1&gid=2)
    const photoswipeParseHash = function () {
        const hash = window.location.hash.substring(1),
            params = {};

        if (hash.length < 5) {
            return params;
        }

        const consts = hash.split('&');
        for (let i = 0; i < consts.length; i++) {
            if (!consts[i]) {
                continue;
            }
            const pair = consts[i].split('=');
            if (pair.length < 2) {
                continue;
            }
            params[pair[0]] = pair[1];
        }

        if (params.gid) {
            params.gid = parseInt(params.gid, 10);
        }

        return params;
    };

    const openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
        let pswpElement = document.querySelectorAll('.pswp')[0],
            gallery,
            options,
            items,
            currentGalleryIndex;

        items = parseThumbnailElements(galleryElement);

        // define options (if needed)
        options = {
            closeEl: true,
            captionEl: true,
            fullscreenEl: false,
            zoomEl: true,
            shareEl: true,
            counterEl: true,
            arrowEl: true,
            history: false,
            clickToCloseNonZoomable: false,
            closeOnScroll: false,
            preloaderEl: true,
            errorMsg: `<img style="opacity: 1; width: 1653px; height: 1102px;" class="pswp__img" src="${FALLBACK_IMAGE}" alt="vehicle image"/>`,
            showAnimationDuration: 220,
            hideAnimationDuration: 200,
            getDoubleTapZoom: function (isMouseClick, item) {

                // isMouseClick          - true if mouse, false if double-tap
                // item                  - slide object that is zoomed, usually current
                // item.initialZoomLevel - initial scale ratio of image
                //                         e.g. if viewport is 700px and image is 1400px,
                //                              initialZoomLevel will be 0.5

                if (isMouseClick) {
                    // is mouse click on image or zoom icon
                    // zoom to original
                    return 1;
                    // e.g. for 1400px image:
                    // 0.5 - zooms to 700px
                    // 2   - zooms to 2800px
                } else {
                    // is double-tap
                    // zoom to original if initial zoom is less than 0.7x,
                    // otherwise to 1.5x, to make sure that double-tap gesture always zooms image
                    return item.initialZoomLevel < 0.7 ? 1 : 1.5;
                }
            },
            galleryUID: galleryElement.getAttribute("data-pswp-uid"),
            getThumbBoundsFn: function (index) {
                return getThumbnailBounds(items[index]);
            }
        };

        // PhotoSwipe opened from URL
        if (fromURL) {
            if (options.galleryPIDs) {
                // parse real index when custom PIDs are used
                // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                for (let j = 0; j < items.length; j++) {
                    if (items[j].pid === index) {
                        options.index = j;
                        break;
                    }
                }
            } else {
                // in URL indexes start from 1
                options.index = parseInt(index, 10) - 1;
            }
        } else {
            options.index = parseInt(index, 10);
        }

        // exit if index not found
        if (isNaN(options.index)) {
            return;
        }

        currentGalleryIndex = options.index;

        if (disableAnimation) {
            options.showAnimationDuration = 0;
        }

        // Pass data to PhotoSwipe and initialize it
        // Was giving a PhotoSwipe is not defined error
        // eslint-disable-next-line
        gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();

        gallery.listen('afterChange', function () {
            const nextGalleryIndex = gallery.getCurrentIndex();

            if (nextGalleryIndex === currentGalleryIndex) {
                return;
            }

            currentGalleryIndex = nextGalleryIndex;
            const currentItem = items[currentGalleryIndex];
            utils.fireEvent('updateVehicleSwiper', currentItem && currentItem.swiperIndex !== undefined ? currentItem.swiperIndex : currentGalleryIndex);
        });

    };

    // loop through all gallery elements and bind events
    const galleryElements = document.querySelectorAll(gallerySelector);

    for (let i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute('data-pswp-uid', i + 1);
        galleryElements[i].onclick = onThumbnailsClick;
    }

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    const hashData = photoswipeParseHash();
    if (hashData.pid && hashData.gid) {
        openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
    }
};

// execute above function
module.exports = initPhotoSwipeFromDOM;
